import { ActionTypes } from "../constants/actionTypes";
import { apiService } from "../../services/apiServices";

export const createSpecialDeliveryOrder = (
  requestObject,
  authParams,
  history,
  handleError,
) => {
  return async (dispatch) => {
    dispatch({ type: ActionTypes.SET_LOADER });

    try {
      const response = await apiService.createSpecialDelivery(
        requestObject,
        authParams,
      );

      dispatch({
        type: ActionTypes.SPECIAL_DELIVERY_INTAKE_SUCCESS,
        payload: response?.data,
      });

      return response?.data;
    } catch ({ response = {} }) {
      const { data = "Network Error!", status } = response;

      dispatch({
        type: ActionTypes.SPECIAL_DELIVERY_INTAKE_FAILURE,
        payload: data,
      });

      if (status === 401) return history("/unauthorized");
      handleError({ data });
    } finally {
      dispatch({ type: ActionTypes.UNSET_LOADER });
    }
  };
};

export const assignSpecialDeliveryTour = (
  requestObject,
  authParams,
  history,
  handleError,
) => {
  return async (dispatch) => {
    dispatch({ type: ActionTypes.SET_LOADER });

    try {
      const response = await apiService.assignSpecialDelivery(
        requestObject,
        authParams,
      );

      dispatch({
        type: ActionTypes.SPECIAL_DELIVERY_ASSIGN_SUCCESS,
        payload: response?.data,
      });

      return response?.data;
    } catch ({ response = {} }) {
      const { data = "Network Error!", status } = response;

      dispatch({
        type: ActionTypes.SPECIAL_DELIVERY_ASSIGN_FAILURE,
        payload: data,
      });

      if (status === 401) return history("/unauthorized");
      handleError({ data });
    } finally {
      dispatch({ type: ActionTypes.UNSET_LOADER });
    }
  };
};

const unwrapBody = (response) =>
  response?.data?.result?.resultBody ?? response?.data ?? {};

export const fetchSpecialOrders = (authParams, history, handleError) => {
  return async (dispatch) => {
    try {
      const response = await apiService.getSpecialOrders(authParams);
      const orders = unwrapBody(response)?.orders ?? [];
      dispatch({ type: ActionTypes.SET_SPECIAL_ORDERS, payload: orders });
      return orders;
    } catch ({ response = {} }) {
      const { data = "Network Error!", status } = response;
      if (status === 401) return history("/unauthorized");
      if (handleError) handleError({ data });
      return null;
    }
  };
};

export const fetchSpecialDeliveryFleet = (authParams, history, handleError) => {
  return async (dispatch) => {
    try {
      const response = await apiService.getSpecialDeliveryFleet(authParams);
      const body = unwrapBody(response);
      const fleet = {
        vehicles: body?.vehicles ?? [],
        drivers: body?.drivers ?? [],
        transporters: body?.transporters ?? [],
      };
      dispatch({ type: ActionTypes.SET_SPECIAL_FLEET, payload: fleet });
      return fleet;
    } catch ({ response = {} }) {
      const { data = "Network Error!", status } = response;
      if (status === 401) return history("/unauthorized");
      if (handleError) handleError({ data });
      return null;
    }
  };
};
